import React, { useEffect, useState, useContext } from "react";
import { connect } from "react-redux";
import { debug, hasErrors } from "../../utils";
import * as validationService from "../../devices/add-device-modal/validationService";
import { AuthServerCardInput } from "./AuthServerCardInput";
import { CardTypes, AuthServerCardService } from "./AuthServerCardService";
import { getAuthServerById } from "../authService";
import { POPUP_TYPES } from "../../view/popup/PopupContainer";
import { PopupContext } from "../../index";

import { Spinner } from "../../view/Spinner";

function AuthServerCard({ errors, handleClose, cardType = CardTypes.CREATE, authServerId }) {

    const valid = !hasErrors(errors);
    const isCreateMode = cardType === CardTypes.CREATE;
    const formId = "oct-auth-server-form";

    const { setPopup } = useContext(PopupContext);

    const [loading, setLoading] = useState(true);
    const [ip, setIP] = useState("");
    const [baseDN, setBaseDN] = useState("");
    const [serviceName, setServiceName] = useState("");
    const [password, setPassword] = useState("");
    const [passwordTxt, setPasswordTxt] = useState("");
    const [type, setType] = useState("ActiveDirectory");
    const [status, setStatus] = useState(0);
    const [passwordChanged, setPasswordChanged] = useState(false);

    // const [valid, setValid]=useState(!hasErrors(errors))

    const authServerCardService = new AuthServerCardService(cardType, handleClose);

    // const initialState = {
    //     parameterName: null,
    //     parameterValue: null,
    //     selectedParameter: null,
    // }

    const fetchData = async () => {
        if (authServerId && cardType === CardTypes.EDIT) {
            try {
                const authServer = await getAuthServerById(authServerId);
                if (authServer) {
                    setIP(authServer.ip);
                    setBaseDN(authServer.baseDN);
                    setServiceName(authServer.serviceName);
                    setPassword('******');
                    setPasswordTxt(authServer.password);
                    setType(authServer.type);
                    setStatus(authServer.status);
                }
            } catch (error) {
                console.error('Error:', error);
            }
        } else {
            validationService.validateNotEmpty(ip, 'ip');
            validationService.validateNotEmpty(baseDN, 'baseDN');
            validationService.validateNotEmpty(serviceName, 'serviceName');
            validationService.validateNotEmpty(password, 'password');
            validationService.validateNotEmpty(type, 'type');
        }

        setLoading(false);
    };

    useEffect(() => {
        fetchData();

        return () => {
            validationService.cleanState();
        };
        /* eslint-disable react-hooks/exhaustive-deps */
    }, [])//[authServerId, cardType, ip, baseDN, serviceName, password, type]);

    const onIpChange = (value) => {
        validationService.validateNotEmpty(value, 'ip');
        setIP(value);
    }

    const onBaseDNChange = (value) => {
        validationService.validateNotEmpty(value, 'baseDN');
        setBaseDN(value);
    }

    const onServiceNameChange = (value) => {
        validationService.validateNotEmpty(value, 'serviceName');
        setServiceName(value);
    }

    const onPasswordChange = (value) => {
        validationService.validateNotEmpty(value, 'password');
        setPassword(value);
        setPasswordTxt(value);
        setPasswordChanged(true);
    }
    const onTypeChange = (value) => {
        validationService.validateNotEmpty(value, 'type');
        setType(value);
    }

    const onStatusChange = (response) => {
        // alert ('AuthCard: response')
        // alert(response)
        setStatus(response);
        // if (response==='1') {
        //     validationService.validateNotEmpty(response, 'status');           
        // }
        // else {
        //     let status='';
        //     validationService.validateNotEmpty(status, 'status'); 
        // }

    }


    const onPasswordFocus = () => {
        if (!passwordChanged) {
            setPassword('');
            setPasswordTxt('');
            setPasswordChanged(true);
        }
    }


    const isPasswordValid = () => password && password.length >= 6;
    const canSubmit = valid && isPasswordValid();

    const checkConnectivity = () => setPopup(
        {
            type: POPUP_TYPES.AUTH_SERVER_CHECK_CONNECTIVITY,
            ip: ip,
            baseDN: baseDN,
            serviceName: serviceName,
            servicePassword: passwordTxt,
            confirm: onStatusChange
        }
    );


    return (
        <>
            <div className="modal-body modal-v2-body oct_auth-v2-modal-body">
                {loading ? (
                    <div className="oct_auth-v2-modal-loading">
                        <Spinner />
                    </div>
                ) : (
                    <form
                        id={formId}
                        className="oct_auth-v2-form modal-v2-form"
                        autoComplete="off"
                        onSubmit={(event) => {
                            event.preventDefault();
                            if (!canSubmit) {
                                return;
                            }

                            const payload = {
                                ip,
                                baseDN,
                                serviceName,
                                passwordTxt,
                                type,
                                status,
                                passwordChanged,
                                id: authServerId
                            };

                            if (isCreateMode) {
                                authServerCardService.onCreate(payload);
                                return;
                            }

                            authServerCardService.onSave(payload);
                        }}
                    >
                        <div className="oct_auth-v2-form-grid">
                            <AuthServerCardInput
                                label={'IP / URL'}
                                value={ip}
                                onChange={onIpChange}
                                valid={ip}
                                required
                            />

                            <AuthServerCardInput
                                label={'Base DN'}
                                value={baseDN}
                                onChange={onBaseDNChange}
                                valid={baseDN}
                                required
                            />

                            <AuthServerCardInput
                                label={'Service Name'}
                                value={serviceName}
                                onChange={onServiceNameChange}
                                valid={serviceName}
                                required
                            />

                            <AuthServerCardInput
                                label={'Password'}
                                value={password}
                                type={'password'}
                                onFocus={() => onPasswordFocus()}
                                onChange={onPasswordChange}
                                valid={isPasswordValid()}
                                required
                            />

                            <AuthServerCardInput
                                label={'Type'}
                                value={type}
                                onChange={onTypeChange}
                                valid={type}
                                required
                            />
                        </div>

                        {status === '1' && (
                            <div className="oct_auth-server-status is-success">
                                Authentication successful
                            </div>
                        )}

                        {status === '0' && (
                            <div className="oct_auth-server-status is-error">
                                Authentication failed
                            </div>
                        )}
                    </form>
                )}
            </div>

            <div className="modal-footer modal-v2-footer oct_auth-v2-modal-footer">
                <div className="modal-v2-footer-note">
                    <span className="modal-v2-footer-note-star">*</span> Required fields
                </div>
                <div className="modal-v2-footer-actions oct_auth-v2-modal-actions">
                    <button
                        type="button"
                        className="btn modal-v2-btn oct_auth-v2-modal-btn oct_auth-v2-modal-btn-test"
                        onClick={checkConnectivity}
                        disabled={loading}
                    >
                        Test Authentication
                    </button>
                    <button type="button" className="btn modal-v2-btn modal-v2-btn-outline oct_auth-v2-modal-btn" onClick={handleClose}>
                        Cancel
                    </button>
                    <button
                        type="submit"
                        form={formId}
                        className="btn modal-v2-btn modal-v2-btn-primary oct_auth-v2-modal-btn"
                        disabled={loading || !canSubmit}
                    >
                        {isCreateMode ? "Create" : "Save"}
                    </button>
                </div>
            </div>
        </>
    )
}

function mapStateToProps(state) {
    debug("AuthServerCard mapStateToProps:", state);
    const validation = state.validation;
    return {
        errors: validation || {},
    }
}

export default connect(mapStateToProps)(AuthServerCard);
